import { DeviationRequestHistoryRecord } from 'api/deviation-request-detail';
import { customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { DeviationRequestStatus } from 'model/business-enums';

@customElement('deviation-request-change-history-panel')
export class DeviationRequestChangeHistoryPanelCustomElement {
  @bindable history: DeviationRequestHistoryRecord[];

  historyChanged() {
    if (this.history != null) this.history.forEach(record => {
      record['statusClass'] = `--${DeviationRequestStatus[record.status.value].toLowerCase()}`;
    });
  }
}
